import { screenActions } from '../../services';

export const screenDispatcher = dispatch => ( {
  resize: () => dispatch( { type: screenActions.RESIZE } )
} );